/**
 * defa.routers.TermsAndCondtions
 * The Router for the TermsAndConstionsController
 * @version 1.0.0
 */
const TermsAndConditionsRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'terms-and-conditions(/)'              : 'showTermsAndConditions',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default TermsAndConditionsRouter;